<template>
  <v-radio-group v-model = "active"
    :label="label"
    :mandatory="false"
    @change="$emit('input', $event)"    
    hide-details
    >
      <v-layout column>
       <v-flex style="display:flex" v-for="(item, index) in items" :key="index" align-top pa-1>
        <v-radio name="active" :value="item[itemValue] || Object.values(item)[0]" class="shrink mr-2"></v-radio>
        <component :is="createComp(item[itemText] || Object.values(item)[0])"/>
       </v-flex>
     </v-layout> 
  </v-radio-group>
</template>

<script>
  import formats from '../../api/formats.js'
  export default {
    name: 'v-select-radio',
    props: {
      label: null,
      value: null,
      itemText: {
        type: String,
        default: 'text'
      },
      itemValue: {
        type: String,
        default: 'value'
      },
      items: Array,
      default () {
        return []
      }
    },
    data: function () {
      return {
        active: null
      }
    },
    created () {
    },
    mounted () {
      this.active = this.value
    },
    watch: {
      value: function (newValue) {
        this.active = newValue
      }
    },
    computed: {
    },
    methods: {
      createComp (template) {
        return formats.createComp(`<span>${template}</span>`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectRadio.vue?342918ac